<template>
  <button
    class="base-time-cell"
    :class="[stateClass, statusClass, cursorClass, selected ? 'ring-2 ring-primary-100' : '']"
    type="button"
    :aria-label="aria"
    :aria-pressed="selected ? 'true' : 'false'"
    :aria-disabled="isDisabled ? 'true' : 'false'"
    :disabled="isDisabled"
    :data-testid="dataTestid"
    @click="onClick"
  >
    <slot name="prefix" />
    <slot>{{ label }}</slot>
    <slot name="suffix" />
  </button>
</template>

<script>
import { defineComponent, computed } from 'vue'

export default defineComponent({
  name: 'AvailableTimeCell',
  props: {
    label: {
      type: [String, Number],
      default: '-',
    },
    status: {
      type: String,
      default: '',
    },
    selected: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    ariaLabel: {
      type: String,
      default: '',
    },
    dataTestid: {
      type: String,
      default: '',
    },
    // 自定義狀態樣式對應表，鍵為狀態值（available/booking/ban/empty），值為 class 字串
    statusClassMap: {
      type: Object,
      default: () => ({
        available: 'text-white bg-[#00CD20] border-transparent hover:brightness-95',
        booking: 'text-white bg-[rgb(112,192,216)] border-transparent',
        ban: 'text-white bg-[rgb(253,102,139)] border-transparent',
        empty: 'text-gray-600 bg-[lightgray] border-transparent',
      }),
    },
  },
  emits: ['click'],
  setup (props, { emit }) {
    const isDisabled = computed(() => props.disabled || props.loading)
    const stateClass = computed(() => ({
      'opacity-60 pointer-events-none': isDisabled.value,
    }))
    const statusClass = computed(() => props.statusClassMap?.[props.status] || '')
    const cursorClass = computed(() => (!isDisabled.value && props.status === 'available') ? 'cursor-pointer' : 'cursor-not-allowed')
    const aria = computed(() => props.ariaLabel || String(props.label))
    const onClick = (e) => {
      if (!isDisabled.value) emit('click', e)
    }
    return { isDisabled, stateClass, statusClass, cursorClass, aria, onClick }
  },
})
</script>

<style lang="postcss" scoped>
.base-time-cell {
  @apply select-none transition block w-full text-center rounded-[8px] p-[5px] text-base;
}
</style>
